import React from 'react';
import { withStyles,} from '@material-ui/core';
import {Button} from  '@material-ui/core';

const CustomButton = withStyles(theme => ({
  root: {
    color: '#002F6D',
    borderColor: '#002F6D',
    textTransform: 'none',
    borderRadius: '5px',
    variant:"outlined"
  }
}))(Button);


export default CustomButton;
